import axios from "axios";

export const NNAPI = axios.create({
    baseURL: process.env.REACT_APP_APIROUTE,
});
